<template>
  <el-dialog :visible.sync="show" title="选择商品" center width="800px">
    <div class="goods-search">
      <el-form size="small" :inline="true">
        <el-form-item>
          <el-input v-model="search.mall_name" placeholder="请输入商品名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="search.inside_number" placeholder="请输入内部编号"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getAllItems">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="goods-con">
      <div class="goods-table">
        <el-table
          :data="allItems"
          v-loading="tableLoading"
          @selection-change="handleSelectionChange"
          @row-click="clickRow"
        >
          <el-table-column width="55" align="center">
            <template slot-scope="scope">
              <el-radio v-model="submitData" :label="scope.row">&nbsp;</el-radio>
            </template>
          </el-table-column>
          <el-table-column label="商品名称" prop="mall_name" align="center"></el-table-column>
          <el-table-column label="内部编号" prop="inside_number" align="center"></el-table-column>
          <el-table-column label="商城价格" prop="mall_price" align="center"></el-table-column>
        </el-table>
        <div class="goods-paging">
          <el-pagination
            @current-change="changeGoodsPage"
            :page-size="5"
            :current-page="itemsPaging.page_index"
            layout="total, prev, pager, next"
            :total="itemsPaging.total"
          ></el-pagination>
        </div>
      </div>
      <div class="goods-category">
        <el-tree
          :data="categoryTree"
          :props="defaultProps"
          @node-click="handleNodeClick"
          v-loading="treeLoading"
        ></el-tree>
      </div>
    </div>
    <div slot="footer">
      <el-button type="primary" @click="confirm">确定</el-button>
      <el-button @click="close">关闭</el-button>
    </div>
  </el-dialog>
</template>
<script>
import apis from "@/config/apis";
export default {
  data() {
    return {
      submitData: {},
      search: {
        page_index: 1,
        origin_type: "self_build",
        status: "NORMAL"
      },
      allItems: [],
      categoryTree: [],
      defaultProps: {
        children: "children",
        label: "label"
      },
      itemsPaging: {},
      tableLoading: false,
      treeLoading: false
    };
  },
  props: {
    show: Boolean,
    mode: String
  },
  created() {
    this.getCategoryTree();
    this.getAllItems();
    this.submitData = {};
  },
  methods: {
    getCategoryTree() {
      this.treeLoading = true;
      this.$axios.get(apis.category_tree + "/" + 1).then(res => {
        this.categoryTree = res.data.data;
        this.treeLoading = false;
      });
    },
    getAllItems() {
      this.tableLoading = true;
      this.$axios
        .get(apis.items_list, {
          params: this.search
        })
        .then(res => {
          let { data, pagination } = res.data;
          this.allItems = data.items_list;
          this.itemsPaging = pagination;
          this.search.page_index = pagination.page_index;
          this.tableLoading = false;
        });
    },
    //改变树形结构
    handleNodeClick(data) {
      this.search.category_id = data.id;
      this.search.page_index = 1;
      this.getAllItems();
    },
    changeGoodsPage(page_index) {
      this.search.page_index = page_index;
      this.getAllItems();
    },
    confirm() {
      this.show = false;
    },
    close() {
      this.submitData = {};
      this.show = false;
    },
    clickRow(row, event, column) {
      this.submitData = row;
    }
  },
  watch: {
    show: function(bl) {
      if (!bl) {
        this.$emit("close", this.submitData);
      }
    }
  }
};
</script>

<style lang="scss">
.goods-con {
  display: flex;
}

.goods-table {
  flex: 3;
  border: 1px solid #e1e1e1;
}

.goods-paging {
  padding: 15px;
  text-align: right;
}

.goods-category {
  margin-left: 15px;
  flex: 1;
  border: 1px solid #e1e1e1;
  overflow: hidden;
}

.goods-category .el-tree-node__label {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
